import { IStudent } from './i-student';
import { Tutor } from '../tutors/tutor';
import { Person } from '../persons/person';
import { Curriculum } from '../curricula/curriculum';

export class Student extends Person implements IStudent {
    Nationality: string;
    SchoolOrigin: string;
    Id: string;
    HasBrothersOfSchoolAge: boolean;
    RepeatStudent: boolean;
    IsActive: boolean;
    TutorId: string;
    DivisionId: number;
    CurriculumId: number;
    SchoolYearId: number;
    ShiftId: number;
    Tutor: Tutor;
    Payments: any[];
    PendingSubjects: string;
    Course: string;
    Documentations: number[];
    coincidencias: number;
    constructor() {
        super();
        this.Id = '-1';
        this.HasBrothersOfSchoolAge = null;
        this.RepeatStudent = null;
        this.IsActive = true;
        this.TutorId = '-1';
        this.DivisionId = -1;
        this.Documentations = [];
        this.Payments = [];
        this.PendingSubjects = '';
        this.Nationality = '';
        this.Course = '';
        this.SchoolOrigin = '';
    }
    
}



// WEBPACK FOOTER //
// ./src/app/main/models/students/student.ts